const style = {
  gridContainer: {
    mt: 3,
  },
} as const;

export default style;
